import { Directive, EventEmitter, Output } from '@angular/core';

@Directive()
export abstract class Join {
  @Output() switch: EventEmitter<'sign-up' | 'sign-in' | 'logged'> = new EventEmitter();
  loading = false;
}
